<span class="price">
  @if (showThousandthsPlace()) {
    {{ formattedPrice().priceSlicedToHundredth }}<sup>{{ formattedPrice().thousandsPlace }}</sup> €
  } @else {
    {{ formattedPrice().priceRoundedToHundredth }} €
  }
</span>
